import { connect } from 'react-redux';
import { compose, mapProps } from 'recompose';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import { getDeliveryEstimation } from 'staticStoreConfig';
import { DeliveryBadge } from './Delivery';

export default compose(
    connect((state) => ({
        activeStore: activeStoreSelector(state),
    })),
    mapProps(({ activeStore, deliveryEstimation, ...rest }) => {
        const defaultDeliveryEstimation = getDeliveryEstimation(activeStore.code);
        return {
            ...rest,
            deliveryEstimation: deliveryEstimation || defaultDeliveryEstimation,
        };
    }),
)(DeliveryBadge);
